<template>
  <app-modal name="invoice-import-modal" :title="title" width="60%" :esc-to-close="false" @before-open="beforeOpen" @before-close="beforeClose"  hide-footer>
    <div class="row">
      <div class="col-lg-12 container-max-height-scroll-80">
        <ul class="tabs-component-tabs">
          <li  v-if="duplicatedInvoices.length > 0" @click="activeTab = 'TAB_DUPLICATED'" role="presentation" :class="{ 'is-active': activeTab === 'TAB_DUPLICATED' }"
               class="tabs-component-tab">
            {{ $t('invoice.duplicatedInvoices') }} ({{duplicatedInvoices.length}})
          </li>
          <li v-if="verifyInvoices.length > 0" @click="activeTab = 'TAB_VERIFY'" role="presentation" :class="{ 'is-active': activeTab === 'TAB_VERIFY' }"
              class="tabs-component-tab">
            {{ $t('reconciliation.reconciliationInvoice') }} ({{verifyInvoices.length}})
          </li>
          <li  v-if="importedInvoices.length > 0" @click="activeTab = 'TAB_OK'" role="presentation" :class="{ 'is-active': activeTab === 'TAB_OK' }"
               class="tabs-component-tab">
            {{ $t('invoice.successImportedInvoices')  }} ({{importedInvoices.length}})
          </li>
        </ul>

        <div v-if="activeTab === 'TAB_DUPLICATED'" class="row">
          <div class="col-md-12">
            <invoice-list
              :show-index="true"
              :show-filter="false"
              :allow-multi-select="false"
              :active-invoice="activeInvoice"
              :invoices="duplicatedInvoices"
              @on-click="onClickDuplicatedInvoice"
            ></invoice-list>
          </div>
        </div>

        <div v-if="activeTab === 'TAB_VERIFY'" class="row">
          <div class="col-md-12">
            <invoice-list
              :show-index="true"
              :show-filter="false"
              :allow-multi-select="false"
              :active-invoice="activeInvoice"
              :invoices="verifyInvoices"
              @on-click="onClickVerifyInvoice"
            ></invoice-list>
          </div>
        </div>

        <div v-if="activeTab === 'TAB_OK'" class="row">
          <div class="col-md-12">
            <invoice-list
              :show-index="true"
              :show-filter="false"
              :allow-multi-select="false"
              :active-invoice="activeInvoice"
              :invoices="importedInvoices"
              @on-click="onClickInvoice"
            ></invoice-list>
          </div>
        </div>
      </div>
    </div>
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import InvoiceList from '@/portal-components/invoice/invoice-list';
import { mapActions } from 'vuex';


const TABS = {
  TAB_OK: 'TAB_OK',
  TAB_VERIFY: 'TAB_VERIFY',
  TAB_DUPLICATED: 'TAB_DUPLICATED',
};


const INVOICE_TYPES = {
  ORIGINAL: 'ORIGINAL',
  REPLACE: 'REPLACE',
  REPLACED: 'REPLACED',
  MODIFY: 'MODIFY',
  MODIFIED: 'MODIFIED',
  CANCELED: 'CANCELED',
};

export default {
  name: 'InvoiceImportModal',
  components: {
    AppModal,
    InvoiceList,
  },
  data() {
    return {
      title: this.$t('invoice.import'),
      activeTab: TABS.TAB_DUPLICATED,
      activeSubTab: INVOICE_TYPES.ORIGINAL,
      importedInvoices: [],
      importedInvoiceMap: null,
      duplicatedInvoices: [],
      verifyInvoices: [],
      invoiceList: [],
      activeInvoice: {},
      invoiceTypes: ['ORIGINAL', 'REPLACE', 'REPLACED', 'MODIFY', 'MODIFIED', 'CANCELED'],
    };
  },
  computed: {
    activeInvoicesByType() {
      if (this.importedInvoiceMap && this.importedInvoiceMap[this.activeSubTab]) {
        return this.importedInvoiceMap[this.activeSubTab].invoices;
      }
      return [];
    },
  },
  methods: {
    ...mapActions(['addErrorInvoices']),
    showInvoiceList(activeInvoice, invoices, index) {
      this.activeInvoice = activeInvoice;
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.$modal.show('invoice-form-modal', {
            invoiceList: invoices,
            currentIndex: index,
          });
        });
      });
    },
    onClickDuplicatedInvoice(invoice, index) {
      this.showInvoiceList(invoice, this.duplicatedInvoices, index);
    },
    onClickVerifyInvoice(invoice, index) {
      this.showInvoiceList(invoice, this.verifyInvoices, index);
    },
    onClickInvoice(invoice, index) {
      this.showInvoiceList(invoice, this.importedInvoices, index);
    },
    beforeOpen(params) {
      this.importedInvoices = params.model.invoices_uploaded_successfully || [];
      this.verifyInvoices = params.model.invoices_reconciliation || [];
      this.duplicatedInvoices = params.model.invoices_already_exist || [];

      if (this.importedInvoices.length > 0) {
        this.activeTab = TABS.TAB_OK;
      }
      if (this.verifyInvoices.length > 0) {
        this.activeTab = TABS.TAB_VERIFY;
      }
      if (this.duplicatedInvoices.length > 0) {
        this.activeTab = TABS.TAB_DUPLICATED;
      }
    },
    beforeClose() {
      this.$bus.emit('close-invoice-upload-modal');
    },
  },
};
</script>
<style lang="scss" scoped>
 .tabs-component-tabs {
   li {
     padding: 4px 12px;
     font-size: 14px;
   }
 }
</style>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-import-modal.vue